"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var _Core_1 = require("../../../_Core");
var Buttons_1 = require("../../../Buttons");
var Localization_1 = require("../../../Localization");
var Input_styles_1 = require("./Input.styles");
exports.default = (function (props) {
    return (React.createElement(Input_styles_1.Container, null,
        React.createElement(Input_styles_1.DateInput, __assign({}, props, { HasErrors: props.HasErrors })),
        React.createElement(Input_styles_1.ButtonContainer, null,
            React.createElement(Buttons_1.IconButton, { Icon: _Core_1.Icons.CloseThin, ButtonSize: "26px", IconSize: "24px", AriaLabel: Localization_1.strings.DateTimePicker_Label_ClearDate, OnClick: props.OnClear, Title: Localization_1.strings.DateTimePicker_Label_ClearDate }),
            React.createElement(Buttons_1.IconButton, { Icon: _Core_1.Icons.Calendar, ButtonSize: "26px", IconSize: "24px", AriaLabel: Localization_1.strings.DateTimePicker_Label_Calendar, OnClick: props.OnClick, Title: Localization_1.strings.DateTimePicker_Label_Calendar }))));
});
